// @flow
import * as React from 'react';
import DatePicker from 'components/DatePicker';
import Field from './Field';

const DatePickerField = ({
  name,
  label,
  description,
  ...props
}: {
  name: string,
  label?: string,
  description?: string
}) => (
  <Field
    inputProps={props}
    name={name}
    label={label}
    description={description}
    renderInput={({ value, id, qaId, hasError, updateValue }) => (
      <DatePicker
        id={id}
        name={name}
        value={value}
        hasError={hasError}
        data-qa-id={qaId}
        onChange={updateValue}
        {...props}
      />
    )}
  />
);

export default DatePickerField;
